import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import { Box, Typography, Button, Card, CardContent } from "@mui/material";

const About = () => {
  const navigate = useNavigate(); // Initialize navigation function

  const handleNavigation = () => {
    navigate("/about"); // Navigate to the About page

  };

  return (
    <Box sx={{ width: "100%", backgroundColor: "white", justifyContent: "center", justifyItems: "center" }}>
      {/* <Box sx={{width: "100%", backgroundColor: "cyan"}}>
        asas
        </Box>
         */}




      <Box sx={{ maxWidth: "100%", m : "auto",  borderRadius: 2 }}>
        <Box
          sx={{
            display: "flex",
            background: "linear-gradient(135deg, white 30%, #1B263B 100%)",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          {/* Left Section - Text */}
          <Box sx={{ display :"flex", flex: 1 , justifyContent: "center"}}>
            <CardContent>
            <Typography 
      variant="h1" 
      sx={{ textAlign: "center" }} 
      fontWeight="bold" 
      color={"#0279c6"}
    >
      Dr. Tarun Reddy – Advanced Cancer Surgery with Precision and Compassion
    </Typography>
              <Typography variant="body1" sx={{ mt: 1 }}>
                Dr. Tarun Reddy is a renowned Surgical Oncologist specializing in minimally invasive and robotic cancer surgeries. Practicing at Renova Cancer Hospital, Warangal, he combines the latest surgical technology with compassionate, patient-focused care.
              </Typography>
              <br></br>
              <Typography>
                His specializations include Breast Cancer Surgery, Gastrointestinal Cancer Surgery, Head and Neck Cancer Surgery, Gynecologic Oncology, Thoracic Oncology, and Robotic and Minimally Invasive Surgery. With years of experience performing complex oncological surgeries, Dr. Reddy is committed to staying at the forefront of medical advancements in cancer treatment. His approach to care is multidisciplinary, with a strong focus on early diagnosis and prevention, while ensuring compassionate and empathetic patient care. Dr. Reddy’s expertise in advanced surgical oncology techniques and his dedication to his patients make him an excellent choice for anyone in need of specialized cancer care.

              </Typography>

              {/* Read More Button - Navigates to About Page */}
              <Box sx={{ display: "flex", justifyContent: "center", mt: 2 , gap: 2}}>
                <Button onClick={handleNavigation} variant="contained">
                  Contact Us
                </Button>

                <Button onClick={handleNavigation} variant="contained">
                  Book An Appointment
                </Button>
              </Box>

            </CardContent>
          </Box>

          {/* Right Section - Image */}
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "center" },
              m:1
            }}
          >
            <img
              src="assets/images/tarun_reddy.jpeg"
              alt="Profile"
              style={{ width: "70%", maxWidth: "400px", borderRadius: "10px" }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};



export default About;